<!-- Блок отображения текста, когда выбрали "Ответить" -->
<div *ngIf="chat?.id && replyToMessageId" class="conversation-box-input__reply-message">
  <app-message-reply [chatId]="chat?.id" [messageId]="replyToMessageId"></app-message-reply>

  <button
    tuiIconButton
    type="button"
    appearance="icon"
    iconStart="@tui.x"
    size="s"
    [tuiHint]="'common.buttons.delete' | translate"
    (click)="deleteReplyMessage()"
  ></button>
</div>

<!-- Блок отображения текста, когда выбрали "Редактировать" -->
<div *ngIf="chat?.id && editMessageId" class="conversation-box-input__reply-message">
  <app-message-edit [chatId]="chat?.id" [messageId]="editMessageId"></app-message-edit>

  <button
    tuiIconButton
    type="button"
    appearance="icon"
    iconStart="@tui.x"
    size="s"
    [tuiHint]="'common.buttons.delete' | translate"
    (click)="deleteEditMessage()"
  ></button>
</div>

<div class="conversation-box-input__control">
  <!-- Выбор файла (документа) для вложения в сообщение -->
  <chat-attachment *ngIf="allowAttachment" (attachmentConfirmed)="sendAttachments($event)"></chat-attachment>

  <!-- Поле ввода сообщения -->
  <!-- [tuiAppearanceFocus]="focused" -->
  <tui-editor
    #textarea
    #parent="tuiActiveZone"
    class="conversation-box-input__control_message textarea"
    tuiDropdownAlign="right"
    [class.textarea__toolbar_hidden]="!isFormatTextToolbarVisible"
    [(ngModel)]="newMessage"
    (keydown)="onKeydown($event)"
    [tuiDropdown]="chatMembersDropdown"
    [tuiDropdownManual]="isChatMembersDropdownVisible"
    [tuiDropdownMaxHeight]="300"
    [tools]="toolbarTools"
    [placeholder]="'common.fields.writeMessage' | translate"
    (ngModelChange)="onNewMessageChange()"
    (tuiActiveZoneChange)="onTextareaFocusedChange($event)"
  ></tui-editor>

  <div>
    <!-- Запись аудио -->
    <telegram-media-recorder
      *ngIf="!newMessage"
      (recordingSent)="sendVoiceRecording($event)"
      (cancelRecording)="setTextareaFocus()"
    ></telegram-media-recorder>

    <!-- Отправить сообщение -->
    <button
      *ngIf="newMessage && !editMessageId"
      tuiButton
      class="conversation-box-input__control_send"
      type="button"
      appearance="icon"
      aria-label="Отправить"
      size="s"
      (click)="sendMessage()"
    >
      <app-icon [src]="'send'"></app-icon>
    </button>

    <!-- Сохранить отредактированное сообщение -->
    <button
      *ngIf="newMessage && editMessageId"
      tuiIconButton
      class="conversation-box-input__control_edit"
      type="button"
      appearance="icon"
      iconStart="@tui.check"
      size="s"
      [tuiHint]="'common.buttons.save' | translate"
      (click)="editMessage()"
    ></button>
  </div>
</div>

<!-- Выпадающий список пользователей, логин которых хотим подставить в поле сообщения -->
<ng-template #chatMembersDropdown>
  <ng-container *ngIf="isChatMembersDropdownVisible">
    <tui-data-list
      class="select-users-list"
      *ngIf="textarea.nativeFocusableElement"
      (keydown.escape)="textarea.nativeFocusableElement.focus()"
    >
      <button
        tuiOption
        *ngFor="let member of filterChatMembers()"
        class="select-users-list-item"
        [disabled]="!member.username"
        (click)="selectMember(member)"
      >
        <div class="select-users-list-item__photo">
          <tui-avatar
            [src]="
              member.photoPath
                ? (member.photoPath | safe: 'url')
                : (member | userDisplayableName: 'short' | tuiInitials)
            "
            [size]="'m'"
            [round]="true"
            [style.background]="
              !member.photoPath && (member | userDisplayableName: 'short')
                ? (member | userDisplayableName: 'short' | tuiAutoColor)
                : ('' | tuiAutoColor)
            "
          ></tui-avatar>
        </div>

        <div class="select-users-list-item__wrapper">
          <span class="select-users-list-item__title">
            {{ member | userDisplayableName }}
          </span>

          <span
            *ngFor="let organisationJobTitle of member.organisationJobTitles | jobTitles: true"
            class="select-users-list-item__subtitle"
          >
            {{ getMemberDisplayableName(member) }} ({{ organisationJobTitle | orgJobTitleDisplayableName }})
          </span>
        </div>
      </button>
    </tui-data-list>
  </ng-container>
</ng-template>
